import { render, staticRenderFns } from "./VehMakes.vue?vue&type=template&id=620779d1&"
import script from "./VehMakes.vue?vue&type=script&lang=js&"
export * from "./VehMakes.vue?vue&type=script&lang=js&"
import style0 from "./VehMakes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VehMakes.vue"
export default component.exports